import axios from "axios";
import { apiClient } from '../utils/api';
import { leadInfo } from "../utils/variables";

export async function uploadPhoto(formData,item, source) {
    item.querySelector('.button').innerText = 'Uploading';
    return await axios.request({
        headers: {
            ...apiClient.config().headers,
            "Content-Type": "multipart/form-data",
            Accept: 'application/json',
        },
        cancelToken: source.token,
        url: `${apiClient.apiUrl(`api/widget/leads/${leadInfo?.text_id}/files`)}`,
        method: 'post',
        data: formData
    });
}
